import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelDynamic as _vModelDynamic, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/t_logo.png'


const _hoisted_1 = {
  key: 0,
  class: "mt-2 d-flex flex-fill justify-content-center"
}
const _hoisted_2 = { style: {"max-width":"800px"} }
const _hoisted_3 = {
  key: 0,
  class: "text-danger mt-5 fs-4"
}
const _hoisted_4 = {
  key: 1,
  class: "text-center fs-1 fw-bold mb-3"
}
const _hoisted_5 = {
  key: 2,
  class: "text-primary mt-5 fs-4"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 3,
  class: "text-danger mt-5 fs-4"
}
const _hoisted_8 = {
  key: 4,
  class: "text-danger mt-5 fs-4"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = { key: 5 }
const _hoisted_11 = { key: 6 }
const _hoisted_12 = { style: {"max-width":"800px"} }
const _hoisted_13 = { class: "row mt-3" }
const _hoisted_14 = { class: "col-sm-12" }
const _hoisted_15 = { class: "d-flex" }
const _hoisted_16 = {
  key: 7,
  class: "card card-body bg-light align-self-center p-5 mb-0",
  style: {"max-width":"800px"}
}
const _hoisted_17 = { class: "row mb-sm-2" }
const _hoisted_18 = { class: "col-sm-8" }
const _hoisted_19 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_20 = { class: "row mb-sm-2" }
const _hoisted_21 = { class: "col-sm-8" }
const _hoisted_22 = { class: "input-group" }
const _hoisted_23 = ["type"]
const _hoisted_24 = {
  class: "fs-6 position-absolute w-100 text-primary",
  style: {"left":"0px","top":"-8px"}
}
const _hoisted_25 = { class: "badge bg-primary" }
const _hoisted_26 = { class: "row mb-sm-2" }
const _hoisted_27 = { class: "col-sm-8" }
const _hoisted_28 = { class: "input-group" }
const _hoisted_29 = ["type"]
const _hoisted_30 = {
  class: "fs-6 position-absolute w-100 text-primary",
  style: {"left":"0px","top":"-8px"}
}
const _hoisted_31 = { class: "badge bg-primary" }
const _hoisted_32 = { class: "row mb-sm-2" }
const _hoisted_33 = { class: "col-sm-8" }
const _hoisted_34 = {
  key: 8,
  class: "ps-5 pe-5",
  style: {"max-width":"800px"}
}
const _hoisted_35 = { class: "row mt-3" }
const _hoisted_36 = { class: "col-sm-8 offset-sm-4" }
const _hoisted_37 = { class: "d-flex" }
const _hoisted_38 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_ctx.ready)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "text-center" }, [
            _createElementVNode("img", {
              src: _imports_0,
              class: "img-fluid"
            })
          ], -1)),
          (_ctx.invalidUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 不正なURLであるため処理できません。 "))
            : _createCommentVNode("", true),
          (!_ctx.invalidUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Webユーザー登録 "))
            : _createCommentVNode("", true),
          (_ctx.registered)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[11] || (_cache[11] = _createTextVNode(" Webユーザーの登録ありがとうございました。", -1)),
                _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                _cache[13] || (_cache[13] = _createTextVNode(" 下記よりログインしてください。", -1)),
                _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("a", { href: _ctx.loginPath }, "日本歯科衛生協会 Webユーザーサイトログイン", 8, _hoisted_6)
              ]))
            : _createCommentVNode("", true),
          (_ctx.timeout)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 有効期限切れのURLであるため処理できません。 "))
            : _createCommentVNode("", true),
          (_ctx.alreadyRegistered)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[16] || (_cache[16] = _createTextVNode(" ログインID（メールアドレス）は登録済みです。", -1)),
                _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                _cache[18] || (_cache[18] = _createTextVNode(" 下記よりログインしてください。", -1)),
                _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("a", { href: _ctx.loginPath }, "日本歯科衛生協会 Webユーザーサイトログイン", 8, _hoisted_9)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.invalidUrl && !_ctx.alreadyRegistered && !_ctx.registered && !_ctx.timeout && !_ctx.kojinFlg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _cache[21] || (_cache[21] = _createTextVNode(" 日本歯科衛生協会は、取得した個人情報を、弊社が定める「個人情報保護方針」にしたがい適正に管理します。 「", -1)),
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.kojinFlg=true)),
                  href: "#"
                }, "個人情報保護方針"),
                _cache[22] || (_cache[22] = _createTextVNode("」をご確認いただき、同意してお申込みください。 Webユーザー登録をされると、歯科健診の結果をWeb上で確認できるようになります。そのため、Webユーザー登録をされた場合は、健診結果をWebでご覧いただくことに同意されたものとみなします。 ", -1))
              ]))
            : _createCommentVNode("", true),
          (_ctx.kojinFlg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[24] || (_cache[24] = _createStaticVNode("<div class=\"card card-body bg-light align-self-center p-5 mb-0\"> 株式会社日本歯科衛生協会(以下、「日本歯科衛生協会」)は、個人情報の価値と有 用性を認識し、歯科健診および関連する口腔予防活動と、健康保険組合員(家族を含む)、 法人、学校などに対し行う歯科健診・歯科保健相談・保健指導・予防処置など、当社の 総ての事業活動において個人情報を適切に管理することを社会的責務と考えます。日本歯 科衛生協会は、個人の人格尊重に基づいた個人情報保護に取り組み、個人情報保護に関 する方針を以下のとおり定め、当社の業務に従事するすべての者に周知徹底を図り、個人 情報保護に努めます。 <br><br> 1.個人情報の管理 <br><br> 日本歯科衛生協会は、個人情報の取得、利用および提供を適切に行い、個人情報を正確かつ最新の状態に保ち、個人情報の漏えいや不正アクセス、滅失、又はき損等のリスク に関して、安全管理に必要かつ適切な措置を講じるため、個人情報保護マネジメントシステムを確立します。個人情報保護マネジメントシステムを遵守するため、社内管理体制の 整備、従業者教育の徹底、IC カードによるオフィス入退室管理やコンピュータセキュリティ としてウイルスの混入防止など必要な措置を講じます。万が一、問題が発生した場合には、 被害の拡大防止に努め、速やかに是正措置を実施します。 <br><br> 2.個人情報の適切な取得 <br><br> 日本歯科衛生協会は、歯科健診委託元(健康保険組合、企業法人、学校など)から健診受診者の個人情報を取得するときは、利用目的および利用範囲を明確にし、歯科健診依頼元との契約において同意を得た特定された利用目的および必要な利用範囲内で、 適切に個人情報を取扱います。また、直接個人情報を取得するときでも、あらかじめご本 人の同意を得ることなく利用目的の達成に必要な範囲を超えた個人情報の取り扱いを行い ません。 <br><br> 3.個人情報の利用範囲 <br><br> 日本歯科衛生協会は、原則として、個人情報はご本人の健診・診療・健康管理の目的以外には使用しません。 <br><br> 4.個人情報の第三者への開示・提供の禁止 <br><br> 日本歯科衛生協会は、取得した個人情報は適切に管理し、法令に基づき開示・提供する必要がある場合、およびあらかじめ歯科健診委託元、又はご本人から同意を頂いた提 供先以外の第三者に開示・提供は一切いたしません。 <br><br> 5.個人情報の取り扱い委託先の監督 <br><br> 日本歯科衛生協会は、事業の達成に必要な限度において、個人情報を含む業務を外部業者に委託する場合、当該外部業者と個人情報の取り扱いに関する必要な契約を締結す ると同時に、日本歯科衛生協会と同様な個人情報の管理を徹底することを義務づけ適切な 監督を行ないます。 <br><br> 6.ご本人の個人情報の照会・問い合わせ・苦情・相談 <br><br> 個人情報の開示、訂正、追加、削除、消去又は利用の停止などを求められる場合、ご本人であることを確認の上、個人情報に関するご本人の権利に従い合理的な範囲で対応 いたします。また、個人情報の取り扱いに関するご本人からの苦情および相談につきまし ても対応窓口を設置し対応いたします。 <br><br> 7.個人情報法令および国が定める指針、その他の規範の遵守と継続的改善 <br><br> 日本歯科衛生協会は、個人情報の取扱いに関する法令および国が定める指針、その他 規範を遵守すると共に個人情報保護を適切に維持するために、個人情報保護マネジメント システムを確立し、運用状況について定期的に監査を実施し、継続的な改善に努めます。 <br><br> 8.個人情報取扱事業者の名称等 <br><br><span> 株式会社日本歯科衛生協会<br> 〒 152-0031 東京都目黒区中根 2-12-1<br> 代表取締役 澤井 淳一 </span></div>", 1)),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary btn-lg text-white flex-fill",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.kojinFlg=false))
                        }, [
                          _createVNode(_component_fa, {
                            class: "me-2",
                            icon: "check"
                          }),
                          _cache[23] || (_cache[23] = _createTextVNode("承知します", -1))
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.invalidUrl && !_ctx.alreadyRegistered && !_ctx.registered && !_ctx.timeout && !_ctx.kojinFlg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", { class: "col-form-label col-sm-4" }, [
                    _createElementVNode("span", { class: "badge bg-danger me-2" }, "必須"),
                    _createTextVNode("ユーザーID（メールアドレス）")
                  ], -1)),
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      ref: "inputUserId",
                      type: "text",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userId) = $event)),
                      class: "form-control form-control-lg",
                      onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.userIdOperation && _ctx.userIdOperation(...args))),
                      style: _normalizeStyle({'background-color': _ctx.userIdValid ? '' : 'lightpink'})
                    }, null, 36), [
                      [_vModelText, _ctx.userId]
                    ]),
                    (_ctx.maiAddressMessage)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.maiAddressMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _cache[26] || (_cache[26] = _createElementVNode("label", { class: "col-form-label col-sm-4" }, [
                    _createElementVNode("span", { class: "badge bg-danger me-2" }, "必須"),
                    _createTextVNode("パスワード")
                  ], -1)),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        ref: "inputPassword",
                        type: _ctx.showPassword ? 'type' :'password',
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.password) = $event)),
                        class: "form-control form-control-lg",
                        style: _normalizeStyle({'background-color': !_ctx.password ? '' : (_ctx.validPassword ? 'aquamarine' : 'lightpink')}),
                        maxlength: "32"
                      }, null, 12, _hoisted_23), [
                        [_vModelDynamic, _ctx.password]
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-lg border-start-0 bg-white",
                        style: {"border-color":"lightgray"},
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showPassword=!_ctx.showPassword))
                      }, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.showPassword ? '非表示' : '表示'), 1)
                        ]),
                        _createVNode(_component_fa, {
                          class: "me-1 text-primary",
                          icon: _ctx.showPassword ? 'eye-slash' : 'eye'
                        }, null, 8, ["icon"])
                      ])
                    ])
                  ])
                ]),
                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "row mb-sm-2" }, [
                  _createElementVNode("div", { class: "col-sm-8 offset-sm-4" }, [
                    _createTextVNode(" 8～32文字で入力してください。"),
                    _createElementVNode("br"),
                    _createTextVNode(" 英文字(大文字、小文字)、数字、記号の2種類以上で作成してください。"),
                    _createElementVNode("br"),
                    _createTextVNode(" ※使用可能な記号  ! # $ % & / = ? @ ")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_26, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", { class: "col-form-label col-sm-4" }, [
                    _createElementVNode("span", { class: "badge bg-danger me-2" }, "必須"),
                    _createTextVNode("パスワード（確認用）")
                  ], -1)),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        onPaste: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
                        type: _ctx.showPassword ? 'type' :'password',
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                        class: "form-control form-control-lg",
                        style: _normalizeStyle({'background-color': !_ctx.confirmPassword ? '' : ((_ctx.password===_ctx.confirmPassword) ? 'aquamarine' : 'lightpink')}),
                        maxlength: "32"
                      }, null, 44, _hoisted_29), [
                        [_vModelDynamic, _ctx.confirmPassword]
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-lg border-start-0 bg-white",
                        style: {"border-color":"lightgray"},
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showPassword=!_ctx.showPassword))
                      }, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.showPassword ? '非表示' : '表示'), 1)
                        ]),
                        _createVNode(_component_fa, {
                          class: "me-1 text-primary",
                          icon: _ctx.showPassword ? 'eye-slash' : 'eye'
                        }, null, 8, ["icon"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _cache[28] || (_cache[28] = _createElementVNode("label", { class: "col-form-label col-sm-4" }, [
                    _createElementVNode("span", { class: "badge bg-danger me-2" }, "必須"),
                    _createTextVNode("氏名")
                  ], -1)),
                  _createElementVNode("div", _hoisted_33, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.userName) = $event)),
                      class: "form-control form-control-lg"
                    }, null, 512), [
                      [_vModelText, _ctx.userName]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.invalidUrl && !_ctx.alreadyRegistered && !_ctx.registered && !_ctx.timeout && !_ctx.kojinFlg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("button", {
                        ref: "registerButton",
                        class: "btn btn-lg btn-primary text-white flex-fill",
                        disabled: !_ctx.canRegister,
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.register()))
                      }, [
                        _createVNode(_component_fa, {
                          class: "me-1",
                          icon: "user-plus"
                        }),
                        _cache[30] || (_cache[30] = _createTextVNode("登録する", -1))
                      ], 8, _hoisted_38)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}